<template>
  <section
    v-if="variants.v1 === variant"
    class="n-section-primary tw-bg-cover tw-bg-center"
    :style="`background-image: url(${isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage});`"
  >
    <div class="tw-absolute tw-inset-0 tw-opacity-80" :style="`background-color: var(--c-secondary);`"></div>
    <div class="tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <div class="tw-flex tw-flex-wrap tw-justify-center tw-text-center lg:tw-gap-4" v-html="vars.titleHtml"></div>
      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="tw-max-w-2xl tw-text-white"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="buttons" class="tw-m-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :class="`n-${button.type}`"
          >{{ button.label }}</nuxt-link
        >
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="n-section-primary tw-bg-cover tw-bg-center"
    :style="`background-image: url(${isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage});`"
  >
    <div class="tw-absolute tw-inset-0 tw-opacity-80" :style="`background-color: var(--c-primary);`"></div>
    <MotionGroup
      is="div"
      preset="slideVisibleOnceTop"
      class="tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center"
      :duration="700"
    >
      <div class="tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
        <div
          class="tw-flex tw-flex-wrap tw-justify-center tw-text-center tw-text-white lg:tw-gap-4"
          v-html="vars.titleHtml"
        ></div>
        <div v-if="descriptions" class="tw-space-y-1">
          <p
            v-for="({ description }, index) in descriptions"
            :key="`takeaction-description-${index}`"
            class="tw-max-w-2xl tw-text-white"
          >
            {{ description }}
          </p>
        </div>
        <div v-if="buttons" class="tw-m-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`takeaction-button-${index}`"
            :to="button.link"
            :class="`n-${button.type}`"
            >{{ button.label }}</nuxt-link
          >
        </div>
      </div>
    </MotionGroup>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="n-section-primary tw-bg-cover tw-bg-center"
    :style="`background-image: url(${isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage});`"
  >
    <div class="tw-absolute tw-inset-0 tw-opacity-80" :style="`background-color: var(--c-primary);`"></div>
    <div class="tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <MotionGroup
        is="div"
        preset="popVisible"
        class="tw-flex tw-flex-col tw-items-center tw-text-center"
        :duration="700"
      >
        <div class="tw-mb-4">
          <h2 :style="`color: var(--c-${vars.textColor});`">{{ vars.titleText }}</h2>
        </div>
        <div v-if="descriptions" class="tw-space-y-1">
          <p
            v-for="({ description }, index) in descriptions"
            :key="`takeaction-description-${index}`"
            :style="`color: var(--c-${vars.textColor});`"
            class="tw-max-w-2xl"
          >
            {{ description }}
          </p>
        </div>
        <div v-if="buttons" class="tw-m-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`takeaction-button-${index}`"
            :to="button.link"
            :class="`n-${button.type} tw-w-full md:tw-w-auto`"
            >{{ button.label }}</nuxt-link
          >
        </div>
      </MotionGroup>
    </div>
    <img
      v-if="vars.mascottEnabledBool"
      :src="vars.mascottImage"
      alt="mascott"
      class="tw-pointer-events-none tw-absolute -tw-top-[65px] tw-right-1/2 tw-w-32 tw--scale-x-100 md:-tw-top-[80px] md:tw-w-[160px]"
    />
  </section>
</template>

<script lang="ts">
import { MotionGroup } from '#components';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TakeAction',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },

      isVisible: false,
    };
  },
  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
